module.exports = __webpack_public_path__ + "static/media/lookpreview.c027cb62.png";